// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var coarbitrary = /* #__PURE__ */ Test_QuickCheck_Arbitrary.coarbitrary(Test_QuickCheck_Arbitrary.coarbString);
var map = /* #__PURE__ */ Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen);
var Indeterminate$prime = /* #__PURE__ */ (function () {
    function Indeterminate$prime() {

    };
    Indeterminate$prime.value = new Indeterminate$prime();
    return Indeterminate$prime;
})();
var Undecidable$prime = /* #__PURE__ */ (function () {
    function Undecidable$prime() {

    };
    Undecidable$prime.value = new Undecidable$prime();
    return Undecidable$prime;
})();
var Yes = /* #__PURE__ */ (function () {
    function Yes() {

    };
    Yes.value = new Yes();
    return Yes;
})();
var No = /* #__PURE__ */ (function () {
    function No() {

    };
    No.value = new No();
    return No;
})();
var Indeterminate = /* #__PURE__ */ (function () {
    function Indeterminate() {

    };
    Indeterminate.value = new Indeterminate();
    return Indeterminate;
})();
var Undecidable = /* #__PURE__ */ (function () {
    function Undecidable() {

    };
    Undecidable.value = new Undecidable();
    return Undecidable;
})();
var showB4$prime = {
    show: function (v) {
        if (v instanceof Indeterminate$prime) {
            return "Indeterminate'";
        };
        if (v instanceof Undecidable$prime) {
            return "Undecidable'";
        };
        throw new Error("Failed pattern match at Data.LogicValues.B4 (line 39, column 1 - line 41, column 41): " + [ v.constructor.name ]);
    }
};
var showB4 = {
    show: function (v) {
        if (v instanceof Yes) {
            return "Yes";
        };
        if (v instanceof No) {
            return "No";
        };
        if (v instanceof Indeterminate) {
            return "Indeterminate";
        };
        if (v instanceof Undecidable) {
            return "Undecidable";
        };
        throw new Error("Failed pattern match at Data.LogicValues.B4 (line 33, column 1 - line 37, column 39): " + [ v.constructor.name ]);
    }
};
var $$short = function (v) {
    if (v instanceof Yes) {
        return "Y";
    };
    if (v instanceof No) {
        return "N";
    };
    if (v instanceof Indeterminate) {
        return "I";
    };
    if (v instanceof Undecidable) {
        return "U";
    };
    throw new Error("Failed pattern match at Data.LogicValues.B4 (line 43, column 1 - line 43, column 22): " + [ v.constructor.name ]);
};
var heytingAlgebraB4 = /* #__PURE__ */ (function () {
    return {
        ff: No.value,
        tt: Yes.value,
        not: function (v) {
            if (v instanceof Yes) {
                return No.value;
            };
            if (v instanceof No) {
                return Yes.value;
            };
            if (v instanceof Indeterminate) {
                return Indeterminate.value;
            };
            if (v instanceof Undecidable) {
                return Undecidable.value;
            };
            throw new Error("Failed pattern match at Data.LogicValues.B4 (line 55, column 1 - line 86, column 46): " + [ v.constructor.name ]);
        },
        conj: function (v) {
            return function (v1) {
                if (v instanceof No) {
                    return No.value;
                };
                if (v1 instanceof No) {
                    return No.value;
                };
                if (v instanceof Yes) {
                    return v1;
                };
                if (v1 instanceof Yes) {
                    return v;
                };
                if (v instanceof Indeterminate) {
                    return Indeterminate.value;
                };
                if (v1 instanceof Indeterminate) {
                    return Indeterminate.value;
                };
                if (v instanceof Undecidable && v1 instanceof Undecidable) {
                    return Undecidable.value;
                };
                throw new Error("Failed pattern match at Data.LogicValues.B4 (line 55, column 1 - line 86, column 46): " + [ v.constructor.name, v1.constructor.name ]);
            };
        },
        disj: function (v) {
            return function (v1) {
                if (v instanceof Yes) {
                    return Yes.value;
                };
                if (v1 instanceof Yes) {
                    return Yes.value;
                };
                if (v1 instanceof No) {
                    return v;
                };
                if (v instanceof No) {
                    return v1;
                };
                if (v instanceof Indeterminate) {
                    return Indeterminate.value;
                };
                if (v1 instanceof Indeterminate) {
                    return Indeterminate.value;
                };
                if (v instanceof Undecidable && v1 instanceof Undecidable) {
                    return Undecidable.value;
                };
                throw new Error("Failed pattern match at Data.LogicValues.B4 (line 55, column 1 - line 86, column 46): " + [ v.constructor.name, v1.constructor.name ]);
            };
        },
        implies: function (v) {
            return function (v1) {
                if (v instanceof Yes) {
                    return v1;
                };
                if (v1 instanceof Yes) {
                    return Yes.value;
                };
                if (v instanceof No) {
                    return Yes.value;
                };
                if (v1 instanceof No) {
                    return Data_HeytingAlgebra.not(heytingAlgebraB4)(v);
                };
                if (v instanceof Indeterminate) {
                    return Indeterminate.value;
                };
                if (v1 instanceof Indeterminate) {
                    return Indeterminate.value;
                };
                if (v instanceof Undecidable && v1 instanceof Undecidable) {
                    return Yes.value;
                };
                throw new Error("Failed pattern match at Data.LogicValues.B4 (line 55, column 1 - line 86, column 46): " + [ v.constructor.name, v1.constructor.name ]);
            };
        }
    };
})();
var graphqlRep = function (v) {
    if (v instanceof Yes) {
        return "YES";
    };
    if (v instanceof No) {
        return "NO";
    };
    if (v instanceof Indeterminate) {
        return "INDETERMINATE";
    };
    if (v instanceof Undecidable) {
        return "UNDECIDABLE";
    };
    throw new Error("Failed pattern match at Data.LogicValues.B4 (line 49, column 1 - line 49, column 27): " + [ v.constructor.name ]);
};
var eqB4$prime = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Indeterminate$prime && y instanceof Indeterminate$prime) {
                return true;
            };
            if (x instanceof Undecidable$prime && y instanceof Undecidable$prime) {
                return true;
            };
            return false;
        };
    }
};
var ordB4$prime = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Indeterminate$prime && y instanceof Indeterminate$prime) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Indeterminate$prime) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Indeterminate$prime) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Undecidable$prime && y instanceof Undecidable$prime) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Data.LogicValues.B4 (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqB4$prime;
    }
};
var eqB = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Yes && y instanceof Yes) {
                return true;
            };
            if (x instanceof No && y instanceof No) {
                return true;
            };
            if (x instanceof Indeterminate && y instanceof Indeterminate) {
                return true;
            };
            if (x instanceof Undecidable && y instanceof Undecidable) {
                return true;
            };
            return false;
        };
    }
};
var ordB4 = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Yes && y instanceof Yes) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Yes) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Yes) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof No && y instanceof No) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof No) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof No) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Indeterminate && y instanceof Indeterminate) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Indeterminate) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Indeterminate) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Undecidable && y instanceof Undecidable) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Data.LogicValues.B4 (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqB;
    }
};
var coarbitraryB4$prime = {
    coarbitrary: /* #__PURE__ */ (function () {
        var $43 = Data_Show.show(showB4$prime);
        return function ($44) {
            return coarbitrary($43($44));
        };
    })()
};
var coarbitraryB4 = {
    coarbitrary: function ($45) {
        return coarbitrary($$short($45));
    }
};
var arbitraryB4$prime = /* #__PURE__ */ (function () {
    return {
        arbitrary: Test_QuickCheck_Gen.oneOf(map(pure)(Data_Array_NonEmpty["cons$prime"](Indeterminate$prime.value)([ Undecidable$prime.value ])))
    };
})();
var arbitraryB4 = /* #__PURE__ */ (function () {
    return {
        arbitrary: Test_QuickCheck_Gen.oneOf(map(pure)(Data_Array_NonEmpty["cons$prime"](Yes.value)([ No.value, Indeterminate.value, Undecidable.value ])))
    };
})();
export {
    Indeterminate$prime,
    Undecidable$prime,
    Yes,
    No,
    Indeterminate,
    Undecidable,
    graphqlRep,
    $$short as short,
    eqB,
    ordB4,
    eqB4$prime,
    ordB4$prime,
    showB4,
    showB4$prime,
    heytingAlgebraB4,
    arbitraryB4,
    coarbitraryB4,
    arbitraryB4$prime,
    coarbitraryB4$prime
};
//# sourceMappingURL=index.js.map
